'use client'

import { useContext, useState, useEffect } from 'react'
import { TranslationContext } from '@/phrase/context/TranslationContext'
import clsx from 'clsx'
import Image from 'next/image'

const LANGUAGES = [
  { code: 'en', label: 'EN', flag: '/flags/gb.svg' },
  { code: 'zh', label: 'ZH', flag: '/flags/cn.svg' },
  { code: 'th', label: 'TH', flag: '/flags/th.svg' },
  { code: 'ru', label: 'RU', flag: '/flags/ru.svg' },
  // { code: 'tl', label: 'TL', flag: '/flags/tl.svg' },
  { code: 'id', label: 'ID', flag: '/flags/id.svg' },
  { code: 'vi', label: 'VI', flag: '/flags/vn.svg' },
  { code: 'ms', label: 'MS', flag: '/flags/my.svg' },
  { code: 'hi', label: 'HI', flag: '/flags/in.svg' },
  { code: 'es', label: 'ES', flag: '/flags/es.svg' },
  { code: 'fr', label: 'FR', flag: '/flags/fr.svg' },
  { code: 'pt', label: 'PT', flag: '/flags/pt.svg' },
  { code: 'ar', label: 'AR', flag: '/flags/sa.svg' },
  { code: 'tr', label: 'TR', flag: '/flags/tr.svg' },
  { code: 'my', label: 'MY', flag: '/flags/mm.svg' },
  { code: 'ko', label: 'KO', flag: '/flags/kr.svg' },
]

const FLAG_URLS = LANGUAGES.map((l) => l.flag)

function PreloadImages() {
  useEffect(() => {
    FLAG_URLS.forEach((src) => {
      const img = document.createElement('img')
      img.src = src
    })
  }, [])
  return null
}

export default function LanguageSwitcher() {
  const { locale, changeLanguage } = useContext(TranslationContext)
  const [isOpen, setIsOpen] = useState(false)

  const currentLang = LANGUAGES.find((lang) => lang.code === locale)

  const handleSelect = (code: string) => {
    changeLanguage(code)
    setIsOpen(false)
  }

  return (
    <div className="relative w-fit text-white font-semibold flex items-center">
      <PreloadImages />
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-1 px-2  py-2 rounded-xl cursor-pointer "
      >
        {currentLang && (
          <>
            <Image
              src={currentLang.flag}
              alt={currentLang.label}
              width={20}
              height={20}
              className="rounded-full w-7.5 h-7.5 object-cover"
            />
            <span className="text-sm ">{currentLang.label}</span>
          </>
        )}
        <svg className="w-4 h-4 fill-white" viewBox="0 0 20 20">
          <path d="M5.25 7.5L10 12.25L14.75 7.5H5.25Z" />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute left-0 bottom-full mb-2 md:bottom-auto md:top-full md:mt-2 z-10 bg-white text-black rounded-md shadow-lg self-baseline w-fit max-h-75 overflow-y-auto">
          {LANGUAGES.map((lang) => (
            <div
              key={lang.code}
              onClick={() => handleSelect(lang.code)}
              className={clsx(
                'flex items-center px-4 py-2 cursor-pointer hover:bg-purple-100',
                lang.code === locale && 'bg-purple-200'
              )}
            >
              <Image
                src={lang.flag}
                alt={lang.label}
                width={20}
                height={14}
                className="mr-2 rounded-full w-5 h-5 object-cover"
              />
              <span>{lang.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
